(function(){

    var tenants =
    {        
        VITAS: "vitas",
        VITAS_EG: "vitas-eg",
        VITAS_LEB:"vitas-leb",
        VITAS_IRQ: "vitas-irq",
        SILK: 'silk',
        UBANK:"ubank",
        SAMBA:"samba",
        SONERI:"soneri",
        BOP: "bop",
        ICBC: "icbc"
    }

    var entityStatuses = {
        None: {
            "LookupId": "0000",
            "VisibleValue": "None"
        },
        Add: {
            "LookupId": "0001",
            "VisibleValue": "Create"
        },
        Update: {
            "LookupId": "0002",
            "VisibleValue": "Update"
        },
        Delete: {
            "LookupId": "0003",
            "VisibleValue": "Delete"
        },        
        DDeactivate: {
            "LookupId": "0004",
            "VisibleValue": "Deactivate"
        }
    };

    var requestStatuses = {
        New: {
            "LookupId": "0011",
            "VisibleValue": "New"
        },
        Approve: {
            "LookupId": "0012",
            "VisibleValue": "Approve"
        },
        Reject: {
            "LookupId": "0013",
            "VisibleValue": "Reject"
        }

    };

    var requestTypes = { 
        UserRequest : {
            LookupId : "0001",
            VisibleValue: "User Modification Request"
        },
        LookupRequest : {
            LookupId : "0002",
            VisibleValue: "Lookup Modification Request"
        },
        RoleRequest : {
            LookupId : "0003",
            VisibleValue: "Role Management Request"
        },
        BranchRequest : {
            LookupId : "0004",
            VisibleValue: "Branch Modification Request"
        },
    };


    var lookupHiddenValues={
        AssignToMe:'AssignToMe',
        LoanProduct:'1',
        TradeProduct:'3',
        AccountProduct:'2',
        LoanLead:'1',
        AccountLead:'2',
        ubankHiddenValue:{
            otherReligion: '4'
        },
        lebHiddenValue:{
            PersonMaritalStatusLkp: '2',
            PersonMaritalStatusUnregisteredLkp: '6',
            partTimeOccupationType: '1',
            fullTimeOccupationType: '2',
            selfEmployedOccupationType: '3',
            retiredOccupationType: '5',
            limitedContractType: '2',
            nonKinship : 'NOKINSHIP',
            yesLkp: '1',
            noLkp: '0',
            beneficialOwnerAdditionalRole: '2',
            relationTypeCommitment: '4',
            businessPremisesOwnership: '3',
            Passport:'18',
            Lebanese:'LB',
            unEmployedOccupationType:'4',
            peddlerYesValue:'1',
            Lebanon: 'Lebanon'
        },
        egyptHiddenValue:{
            ofacClearedYes: '8'
        },
        jorHiddenValue:{
            IDTypeArmyCard:'4'
        }
    }

    var lookupTypes = {
        COLLATERALS_RATE: 'CollateralRate',
        ACCOUNT_APP_PDF_TYPES: 'ACC_PDF_TYPE',
        LOAN_APP_PDF_TYPES:'LOAN_PDF_TYPE',
        TRADE_TRN_PDF_TYPE: 'TRADE_PDF_TYPE',
        REPORT_TYPE:'REPORT_TYPE',
        PROVINCE : 'Province',
        ID_TYPE :'ID Type',
        COMPANY :'Company',
        COMPANY_SEGMENT: 'COMPANY_SEGMENT',
        CUST_SEGMENT:'CUST_SEGMENT',
        TYPE_OF_JOB:'Type of Job',
        LOCATION_TYPE_CITY:'LOCATION_TYPE_CITY',
        YES_NO:'YES_NO',
        TRUE_FALSE_BIT:'TRUE_FALSE_BIT',
        TRUE_FALSE:'TRUE_FALSE',
        DESIGNATION:'DESIGNATION',
        IdentificationDocumentTypes:'IdentificationDocumentTypes',
        YES_NO_BIT:'YES_NO_BIT',
        SECTOR:'SECTOR',
        GENDER:'GENDER',
        RejectionTypes:'RejectionTypes',
        CIU_REJECTION_CODES:'CIU_REJECTION_CODES',
        Deviation_Status:'Deviation_Status',
        BTF_GF:'BTF_GF',
        LOCATION_TYPE_AREA:'LOCATION_TYPE_AREA',
        USER:'USER',
        COMPANY_TYPE:'COMPANY_TYPE',
        COMPANY_CLASS:'COMPANY_CLASS',
        LOCATION_TYPE: 'LOCATION_TYPE',
        DecisionTypes:'DecisionTypes',
        APPLICATION_STATUS : 'APPLICATION_STATUS',
        ADDRESS_TYPE:'Address Type',
        LoanUsageTypes:'LoanUsageTypes',
        CURRENCY_WITH_RATE:'CURRENCY_WITH_RATE',
        Funds:'Funds',
        LoanProducts:'LoanProducts',
        Product:'Product',
        CustomerCriteria:'CC_TYPE_OF_CUSTOMER',
        LEAD_GENERATOR:'LEAD_GENERATOR',
        LEAD_TYPE:'LEAD_TYPE',
        SA_EMPLOYER_STATUS:'SA_EMPLOYER_STATUS',
        INDUSTRY_TYPE:'INDUSTRY_TYPE',
        ORGANIZATION_TYPE:'ORGANIZATION_TYPE',
        ORGANIZATION_RELATION:'ORGANIZATION_RELATION',
        BULK_UPLOAD_TYPES:'BULK_UPLOAD_TYPES',
        TRADE_ID_TYPE:'TRADE_ID_TYPE',
        TRADE_APP_TYPE:'TRADE_APP_TYPE',
        CLIENT_TYPE:'Client_Type',
        PRODUCT_CLASSIFICATION:'PRODUCT_CLASSIFICATION',
        COMMAND_APPLICATION_STATUS_MAPPING:'Command_Application_Status_Mapping',
        IdentificationDocumentTypesStaticPage:'IdentificationDocumentTypesStaticPage',
        ROLE_STATUS_MAPPING:'ROLE_STATUS_MAPPING',
        SA_APPLICATION_STATUS:'ADVANCE_STATUS',
        Nationalities:'Nationalities',
        TransactionStatus:'TransactionStatus',
        IdentType: 'IdentType'
    }

    var currencyTypes = {
        lbpCurrency: 'LBP',
        pkrCurrency: 'PKR',
        usdCurrency: 'USD'
    }
    var roleNames = {
        ITAdmin:'IT Admin',
        Treasury:'TR'
    }

    var encryptionKey = {
        key: 'tmxfinance_encryption_decryptkey',
        iv: 'tmxMF_decrypt_iv' 
    }

    var pageOrientation = {
        Portrait:"portrait",
        Landscape:"landscape"
    }
    var dashboardTypes = {
        POWERBI:'POWERBI',
        ProductDashboard:'ProductDashboard'
    }

    var transactionTypes ={
        LOANAPPLICATION:'LoanApplication',
        ACCOUNTAPPLICATION:'AccountApplication',
        TRADE:'TradeRepository'
    }

    var statusBakgroundColor={        
        active:{'background-color': '#1caf9a'}, //green
        inactive:{'background-color': '#c51b26'},
        draft: {'background-color': 'grey'},
        reject:{'background-color': '#c51b26'},
        cancel:{'background-color': '#c51b26'},
        approve:{'background-color': '#1caf9a'},
        approved:{'background-color': '#1caf9a'},
        "process transaction":{'background-color': '#1caf9a'},
        "recommended":{'background-color': '#1caf9a'},
        "not recommended":{'background-color': '#c51b26'},
        outstanding:{'background-color': '#0091EA'},
        "in process": {'background-color': 'grey'},
        "partially paid":{'background-color': '#0091EA'},
        "non performing":{'background-color': '#c51b26'},
        recovered:{'background-color': '#1caf9a'}
    };

    var fingerprintSupportedDevices = {
        "SECUGEN": "SECUGEN", "CENTERM": "CENTERM", "FGTIT": "FGTIT"
    }

    var defaultBackgroundColor={'background-color': '#0091EA'}; //blue

    var configurationConstants = {
        "FGTIT_WS_URL":"ws://127.0.0.1:21187/fps"
    }

    angular.module('tmx-app').
        constant('TMX_FINANCE_CONSTANTS', {
            "REQUEST_TYPES" : requestTypes,
            "REQUEST_STATUSES": requestStatuses,
            "ENTITY_STATUSES": entityStatuses,
            "TENANTS":tenants,
            "LOOKUP_HV":lookupHiddenValues,
            'ROLE_NAMES':roleNames,
            'LOOKUP_TYPES':lookupTypes,
            'CURRENCY_TYPES': currencyTypes,
            'ENCRYPTION_KEY':encryptionKey,
            "PAGE_ORIENTATION":pageOrientation,
            "DASHBOARD_TYPES":dashboardTypes,
            "STATUS_BACKGROUND_COLOR":statusBakgroundColor,
            "DEFAULT_STATUS_BACKGROUND_COLOR":defaultBackgroundColor,
            "SUPPORTED_DEVICES_FINGERPRINT":fingerprintSupportedDevices,
            "CONFIGS":configurationConstants,
            "TRANSACTION_TYPES":transactionTypes
        });
})();